import { genId } from '@/utils/id'
import { seedTodos } from '@/mock/seed'
import { filterVisible } from '@/utils/visibility'

export default {
  namespaced: true,
  state: {
    list: seedTodos
  },
  getters: {
    byTrip: state => tripId => state.list.filter(t => t.tripId === tripId),
    visibleByTrip: (state, getters) => (tripId, viewerId) => filterVisible(getters.byTrip(tripId), viewerId)
  },
  mutations: {
    ADD_TODO (state, todo) {
      state.list.unshift(todo)
    },
    UPDATE_TODO (state, { id, patch }) {
      const t = state.list.find(x => x.id === id)
      if (t) Object.assign(t, patch)
    },
    REMOVE_TODO (state, id) {
      state.list = state.list.filter(t => t.id !== id)
    }
  },
  actions: {
    createTodo ({ commit }, { tripId, title, assigneeId, due, pointId, note, visibility, createdBy }) {
      const id = genId()
      commit('ADD_TODO', {
        id, tripId, title, assigneeId: assigneeId || null, due: due || null,
        pointId: pointId || null, note: note || '', visibility: visibility || 'trip',
        createdBy, done: false, doneAt: null
      })
      return id
    },
    toggleDone ({ commit, state }, id) {
      const t = state.list.find(x => x.id === id)
      if (!t) return
      commit('UPDATE_TODO', { id, patch: { done: !t.done, doneAt: !t.done ? new Date().toISOString() : null } })
    },
    removeTodo ({ commit }, id) {
      commit('REMOVE_TODO', id)
    }
  }
}
